<template>
  <div>
    <!-- :title="
                moduleType==1?'保洁服务':
                moduleType==2?'保安服务':
                moduleType==3?'陪护服务':
                moduleType==4?'运送服务':
                moduleType==5?'投诉监督':
                moduleType==6?'用车服务':
                moduleType==7?'报修服务':
                moduleType==8?'设备维保服务':
                moduleType==9?'设备巡检':
                moduleType==10?'区域巡检':''
            " -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="80%"
      top="60px"
      :fullscreen="dialogFull"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :before-close="handleClose"
      append-to-body
      :modal-append-to-body="false"
      v-loading="loading < 40"
    >
    <template slot="title">
                <div class="avue-crud__dialog__header">
                        <span class="el-dialog__title">
                            查 看
                        </span>
                        <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>
                        
                </div>
      </template>
      <div v-if="dialogVisible">
        <div style="display: flex; justify-content: space-between">
          <div style="font-size: 20px">
            <!-- <span  style="font-size:20px;font-weight:bold;">{{ orderDetailForm.code }}</span> -->
            <span style="font-size: 20px; font-weight: bold">工单编号:</span
            >{{ orderDetailForm.code }}
            <span style="font-size: 20px; font-weight: bold">来电类型:</span
            >{{ orderDetailForm.moduleTypeName }}
            <!-- <span style="font-size:20px;font-weight:bold;">工单名称:</span> -->
            <!-- <span style="font-size:20px;">
                    {{ orderDetailForm.orderName }}
                </span> -->
            <el-tag type="success">{{ orderDetailForm.statusName }}</el-tag>
          </div>
          <div>
            <!-- opensettingSynergy -->
            <!-- <el-button style="margin:0 10px" type="primary" @click="openConfirmDialog">确认</el-button> -->
            <!-- <el-button style="margin:0 10px"  type="primary" @click="opensettingSynergy">协同人</el-button> -->
            <!-- <el-button style="margin:0 10px"  type="primary" @click="openRobOrderDialog">抢单</el-button> -->
            <!-- <el-button style="margin:0 10px" type="primary" @click="openRobOrderDialog(3)">接受</el-button> -->
            <!-- <el-button style="margin:0 10px" type="primary" @click="openComplaintDialog(4)">转办</el-button> -->
            <!-- <el-button style="margin:0 10px"  type="primary" @click="openStartOrderDialog(5)">开始</el-button> -->
            <!-- 延迟 恢复 -->
            <!-- <el-button style="margin:0 10px"  type="primary" @click="openDelayDialog(6)">延迟</el-button>
                    <el-button style="margin:0 10px"  type="primary" @click="openRecoverDialog(7)">恢复</el-button> -->

            <!-- <el-button style="margin:0 10px"  type="primary" @click="openFinishDialog(8)">完成</el-button> -->
            <!-- <el-button style="margin:0 10px"  type="primary" @click="openEvaluateDialog(9)">评价</el-button> -->
            <!-- <el-button style="margin:0 10px"  type="primary" @click="openVisitDialog">回访</el-button> -->
            <!-- <el-button style="margin:0 10px"  type="primary" @click="openPrintDialog">打印</el-button> -->
            <!-- <el-button style="margin:0 10px"  @click="openCancelDialog(12)">取消</el-button> -->
            <!-- 报事 报修 外委 -->
            <!-- <el-button style="margin:0 10px"  type="primary" @click="openRepairsDialog(13)">报修</el-button> -->
            <!-- <el-button style="margin:0 10px"  type="primary" @click="openScrapDialog(14)">报废</el-button> -->
            <!-- <el-button style="margin:0 10px"  type="primary" @click="openOutsourcingDialog(15)">外委</el-button> -->

            <span v-for="item in orderActiveButton" :key="item">
              <!-- <el-button style="margin:0 10px" v-if="item.dictValue==1" type="primary" @click="openAssignDialog(1)">{{ item.dictKey }}</el-button>
                    <el-button style="margin:0 10px" v-if="item.dictValue==2" type="primary" @click="openRobOrderDialog(2)">{{ item.dictKey }}</el-button> -->
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 1"
                type="primary"
                @click="openAssignDialog(1)"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 2"
                type="primary"
                @click="openGrabSingleDialog(2)"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 3"
                type="primary"
                @click="openRobOrderDialog(item.dictKey)"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 4"
                type="primary"
                @click="openComplaintDialog(4)"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 5"
                type="primary"
                @click="openStartOrderDialog(5)"
                >{{ item.dictKey }}</el-button
              >
              <!-- 延迟 恢复 -->
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 6"
                type="primary"
                @click="openDelayDialog(item.dictKey)"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 7"
                type="primary"
                @click="openRecoverDialog(7)"
                >{{ item.dictKey }}</el-button
              >

              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 8"
                type="primary"
                @click="openFinishDialog(8)"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 9"
                type="primary"
                @click="openEvaluateDialog(9)"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 10"
                type="primary"
                @click="openVisitDialog"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 11"
                type="primary"
                @click="openPrintDialog(11)"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 19"
                type="primary"
                @click="openUrgeDialog"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 16"
                type="primary"
                @click="opensettingSynergy"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 12"
                @click="openCancelDialog(12)"
                >{{ item.dictKey }}</el-button
              >
              <!-- 报事 报修 外委 -->
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 13"
                type="primary"
                @click="openRepairsDialog(13)"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 14"
                type="primary"
                @click="openScrapDialog(14)"
                >{{ item.dictKey }}</el-button
              >
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 15"
                type="primary"
                @click="openOutsourcingDialog(15)"
                >{{ item.dictKey }}</el-button
              >

              <!-- <el-button style="margin:0 10px" v-if="item.dictValue==17" type="primary" @click="openConfirmDialog">{{ item.dictKey }}</el-button> -->
              <el-button
                style="margin: 0 10px"
                v-if="item.dictValue == 18"
                type="primary"
                @click="openConfirmDialog"
                >{{ item.dictKey }}</el-button
              >
            </span>
            <span>
              
            </span>
          </div>
        </div>
        <el-divider></el-divider>
        <div style="display: flex; justify-content: space-between">
          <div class="order-detail" :style="'height:'+dialogBodyHight+'px;overflow:scroll;'">
            <avue-form :option="option" v-model="orderDetailForm">
              <template slot="evaluate">
                <div style="width:250px;">
                      <!-- <div>{{evaluateInfo.content}}</div> -->
                <!-- <input type="text" placeholder="666666"/> -->
                        <div v-for="(item,index) in evaluateDetailList" :key="index" style="overflow:hidden">

                         <div style="display:inline-block;width:5rem;float:left;"> {{getEvaluateType(item.target)}}:</div>
                            <div style="display:inline-block;float:left;height: 2rem;box-sizing: border-box;padding: .4rem 0;"><el-rate
                              v-model="item.level"
                              disabled
                              text-color="#ff9900"
                              score-template="{value}">
                          </el-rate></div><div style="display:inline-block;float:left;color:#f7ba2a">{{tag(item.level)}}</div>
                        </div>
                </div>
              </template>
              <template slot="attachList">
                <!-- <div v-if="!orderDetailForm.attachList.length">暂无内容</div> -->
                <div>
                  <div class="img">
                    <el-image
                      v-for="img in orderDetailForm.imgUrlData"
                      :key="img"
                      style="width: 100px; height: 100px; margin-right: 10px"
                      :src="img.link"
                      :z-index="10000"
                      :preview-src-list="[img.link]"
                      :fit="cover"
                    ></el-image>
                  </div>
                  <div
                    v-for="file in orderDetailForm.fileList"
                    :key="file"
                    class="fileStyle"
                  >
                    <div style="color: #409eff" @click="downloadFile(file)">
                      {{ file.originalName }}
                    </div>
                  </div>
                </div>
              </template>

              <template slot="inspectTaskList">
                <div>
                  <el-table
                    v-if="taskListData && taskListData.length > 0"
                    :data="taskListData"
                  >
                  <el-table-column
                      type="index"
                      label='序号'
                      width="50">
                    </el-table-column>
                    <el-table-column prop="deviceName" label="设备名称aa">
                      <template  slot-scope="scope" >
                               <span>{{scope.row.deviceName}}</span><span v-if="scope.row.assetStatus==2" style="color:red"> (报废)</span>
                        </template>
                    </el-table-column>
                     <el-table-column prop="typeName" label="设备类型">
                    </el-table-column>
                    <el-table-column prop="code" label="设备编号">
                    </el-table-column>
                    <el-table-column prop="deptName" label="所属部门">
                    </el-table-column>
                    <el-table-column prop="areaName" label="存放位置">
                    </el-table-column>
                    <el-table-column prop="realInspectTime" label="执行时间">
                    </el-table-column>
                    <el-table-column prop="realInspectManName" label="执行人员">
                    </el-table-column>  
                    <el-table-column prop="errorFlagStr" label="任务结果">
                       <template slot-scope="scope">
                        <div style="transform: translateY(-25%);">  
                          {{scope.row.errorFlagStr?'完成':'未完成'}}
                        </div>
                      </template>
                    </el-table-column>
                    
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button @click="showTaskDetail(scope.row)">详情</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </avue-form>
          </div>
          <div class="course" :style="'height:'+dialogBodyHight+'px;overflow:scroll;'">
            <el-steps process-status direction="vertical" space="20%" :active="1">
              <el-step
                v-for="(item, index) in courseList"
                :key="item"
                :title="item.orderActionName"
              >
                <template slot="icon">
                  <div class="step-icon">
                    {{ courseList.length - index }}
                  </div>
                </template>
                <template slot="description">
                  <div>
                    {{ item.createTime }}
                    <!-- <el-tag
                                size="mini"
                                type="warning"
                                effect="dark"
                                style="cursor: pointer;"
                                @click="clickDetail(item)"
                                >
                                    详情 <span :class="item.showDetail ? 'el-icon-arrow-up':'el-icon-arrow-down'">
                                </span></el-tag> -->
                  </div>
                  <div>
                    <div>
                      操作人:{{ item.operateUser
                      }}<span v-if="item.phone">{{ "(" + item.phone + ")" }}</span>
                    </div>
                    <div>内容:{{ item.title + " " + item.content }}</div>
                    <div class="img">
                      <el-image
                        v-for="img in item.imgUrlData"
                        :key="img"
                        style="width: 50px; height: 50px; margin-right: 10px"
                        :src="img.link"
                        :z-index="10000"
                        :preview-src-list="[img.link]"
                        :fit="cover"
                      ></el-image>
                    </div>
                    <div v-for="file in item.fileList" :key="file">
                      <div style="color: #409eff" @click="downloadFile(file)">
                        {{ file.originalName }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-step>
            </el-steps>
          </div>
        </div>
        <el-dialog
          title="转办"
          :visible.sync="complaintDialog"
          width="60%"
          :before-close="closeComplaintDialog"
          append-to-body
          :modal-append-to-body="false"
        >
          <avue-form
            ref="complaintForm"
            :option="complaintFormOption"
            v-model="complaintForm"
            v-if="complaintDialog"
            @submit="complaintFormSubmit"
            @error="complaintFormError"
          >
            <template slot="group">
              <el-select :value="complaintForm.group" disabled> </el-select>
            </template>
            <template slot="remark">
              <div>
                <el-input
                  type="textarea"
                  :rows="3"
                  maxlength="500"
                  show-word-limit
                  placeholder="请输入内容"
                  v-model="complaintForm.remark"
                >
                </el-input>
                <remarkModel
                  :remark.sync="complaintForm.remark"
                  ref="complaintFormRemarkModel"
                ></remarkModel>
              </div>
            </template>
            <template slot="menuForm">
              <el-button @click="closeComplaintDialog"
                ><span class="el-icon-close"></span> 取消</el-button
              >
            </template>
          </avue-form>
        </el-dialog>
        <el-dialog
          title="派单"
          :visible.sync="assignDialog"
          width="60%"
          :before-close="closeAssignDialog"
          append-to-body
          :modal-append-to-body="false"
        >
          <avue-form
            :option="assignFormOption"
            v-model="assignForm"
            @submit="assignFormSubmit"
            @error="assignFormError"
          >
            <template slot="menuForm">
              <el-button @click="assignDialog = false"
                ><span class="el-icon-close"></span> 取消</el-button
              >
            </template>
          </avue-form>
        </el-dialog>
        <el-dialog
          title="接受"
          :visible.sync="robOrderDialog"
          width="60%"
          :before-close="closeRobOrderDialog"
          append-to-body
          :modal-append-to-body="false"
        >
          <avue-form
            :option="robOrderFormOption"
            v-model="robOrderForm"
            v-if="robOrderDialog"
            @submit="robOrderFormSubmit"
            @error="robOrderFormError"
          >
            <template slot="menuForm">
              <el-button @click="closeRobOrderDialog"
                ><span class="el-icon-close"></span> 取消</el-button
              >
            </template>
            <template slot="remark">
              <div>
                <el-input
                  type="textarea"
                  :rows="3"
                  maxlength="500"
                  show-word-limit
                  placeholder="请输入内容"
                  v-model="robOrderForm.remark"
                >
                </el-input>
                <remarkModel
                  :remark.sync="robOrderForm.remark"
                  ref="robOrderFormRemarkModel"
                ></remarkModel>
              </div>
            </template>
          </avue-form>
        </el-dialog>
        <el-dialog
          title="开始"
          :visible.sync="startOrderDialog"
          width="60%"
          :before-close="closeStartOrderDialog"
          append-to-body
          :modal-append-to-body="false"
        >
          <avue-form
            :option="startOrderFormOption"
            v-model="startOrderForm"
            v-if="startOrderDialog"
            @submit="startOrderFormSubmit"
            @error="startOrderFormError"
          >
            <template slot="areaId">
              <el-select
                v-model="startOrderForm.areaId"
                :value="startOrderForm.areaId"
                placeholder="请选择需求区域"
                clearable
                ref="addConnectSelect"
              >
                <el-option
                  :value="startOrderForm.areaId"
                  show-all-levels
                  :label="startOrderForm.areaName"
                >
                  <el-tree
                    node-key="id"
                    :data="treeFormAreaData"
                    :props="treeProps"
                    :load="editAreaLazyLoadTree"
                    lazy
                    @node-click="_editAreaNodeTreeClick"
                  >
                  </el-tree>
                </el-option>
              </el-select>
            </template>
            <template slot="attachList">
              <vupload
                :fileList.sync="startOrderForm.attachList"
                :disabled="false"
                :showButton="true"
              ></vupload>
            </template>
            <template slot="remark">
              <div>
                <el-input
                  type="textarea"
                  :rows="3"
                  maxlength="500"
                  show-word-limit
                  placeholder="请输入内容"
                  v-model="startOrderForm.remark"
                >
                </el-input>
                <remarkModel
                  :remark.sync="startOrderForm.remark"
                  ref="startOrderFormRemarkModel"
                ></remarkModel>
              </div>
            </template>
            <template slot="menuForm">
              <el-button @click="closeStartOrderDialog"
                ><span class="el-icon-close"></span> 取消</el-button
              >
            </template>
          </avue-form>
        </el-dialog>
        <el-dialog
          title="取消"
          :visible.sync="cancelDialog"
          width="60%"
          :before-close="closeCancelDialog"
          append-to-body
          :modal-append-to-body="false"
        >
          <avue-form
            :option="cancelFormOption"
            v-model="cancelForm"
            v-if="cancelDialog"
            @submit="cancelFormSubmit"
            @error="cancelFormError"
          >
            <template slot="remark">
              <div>
                <el-input
                  type="textarea"
                  :rows="3"
                  maxlength="500"
                  show-word-limit
                  placeholder="请输入内容"
                  v-model="cancelForm.remark"
                >
                </el-input>
                <remarkModel
                  :remark.sync="cancelForm.remark"
                  ref="cancelFormRemarkModel"
                ></remarkModel>
              </div>
            </template>
            <template slot="attachList">
              <vupload
                :fileList.sync="cancelForm.attachList"
                :disabled="false"
                :showButton="true"
              ></vupload>
            </template>
            <template slot="menuForm">
              <el-button @click="closeCancelDialog"
                ><span class="el-icon-close"></span> 取消</el-button
              >
            </template>
          </avue-form>
        </el-dialog>
        <el-dialog
          title="评价"
          :visible.sync="evaluateDialog"
          width="60%"
          :before-close="closeEvaluateDialog"
          append-to-body
          :modal-append-to-body="false"
        >
          <avue-form
            :option="evaluateFormOption"
            v-model="evaluateForm"
            v-if="evaluateDialog"
            @submit="evaluateFormSubmit"
            @error="evaluateFormError"
          >
            <template slot="target">
              <el-select
                v-model="evaluateForm.target"
                multiple
                collapse-tags
                placeholder="请选择评价对象"
              >
                <el-option
                  v-for="item in evaluateList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </template>
            <template slot="content">
              <div>
                <el-input
                  type="textarea"
                  :rows="3"
                  maxlength="500"
                  show-word-limit
                  placeholder="请输入内容"
                  v-model="evaluateForm.content"
                >
                </el-input>
                <remarkModel
                  :remark.sync="evaluateForm.content"
                  ref="evaluateFormRemarkModel"
                ></remarkModel>
              </div>
            </template>
            <template slot="attachList">
              <vupload
                :fileList.sync="evaluateForm.attachList"
                :disabled="false"
                :showButton="true"
              ></vupload>
            </template>
            <template slot="menuForm">
              <el-button @click="closeEvaluateDialog"
                ><span class="el-icon-close"></span> 取消</el-button
              >
            </template>
          </avue-form>
        </el-dialog>
        <el-dialog
          title="回访"
          :visible.sync="visitDialog"
          width="60%"
          :before-close="closeVisitDialog"
          append-to-body
          :modal-append-to-body="false"
        >
          <avue-form
            :option="visitFormOption"
            v-model="visitForm"
            v-if="visitDialog"
            @submit="visitFormSubmit"
            @error="visitFormError"
          >
            <template slot="menuForm">
              <el-button @click="closeVisitDialog"
                ><span class="el-icon-close"></span> 取消</el-button
              >
            </template>
          </avue-form>
        </el-dialog>
        <el-dialog
          title="打印"
          :visible.sync="printDialog"
          width="60%"
          :before-close="closePrintDialog"
          append-to-body
          :modal-append-to-body="false"
        >
          <div style="width: 100" id="print">
            <table width="100%" border="1" style="border-collapse: collapse">
              <tr>
                <td
                  class="title-name add-width"
                  style="font-weight: bold; width: 100px; line-height: 40px; height: 40px"
                >
                  名称:
                </td>
                <td colspan="3">{{ printForm.orderName }}</td>
                <td class="title-name">编号:</td>
                <td>{{ printForm.code }}</td>
              </tr>
              <tr>
                <td class="title-name">报单人:</td>
                <td>{{ printForm.requireManName }}</td>
                <td class="title-name">电话:</td>
                <td>{{ printForm.requireManPhone }}</td>
                <td class="title-name">部门:</td>
                <td>{{ printForm.requireManDept }}</td>
              </tr>
              <tr>
                <td class="title-name">地址:</td>
                <td colspan="5">{{ printForm.address }}</td>
              </tr>
              <tr>
                <td class="title-name">描述:</td>
                <td colspan="5" class="add-height">{{ printForm.description }}</td>
              </tr>
              <tr>
                <td class="title-name">服务人员:</td>
                <td>{{ printForm.serviceStaff }}</td>
                <td class="title-name">电话:</td>
                <td>{{ printForm.serviceStaffPhone }}</td>
                <td class="title-name">班组:</td>
                <td>{{ printForm.groupName }}</td>
              </tr>
              <tr>
                <td class="title-name">现场记录:</td>
                <td colspan="5" class="add-height">{{ printForm.fieldServiceRecord }}</td>
              </tr>
              <tr>
                <td class="title-name">完工记录:</td>
                <td colspan="5" class="add-height">{{ printForm.completionRecord }}</td>
              </tr>
            </table>
          </div>
          <div style="display: flex; justify-content: flex-end; margin-top: 20px">
            <el-button type="primary" @click="printSubmit">打印</el-button>
            <el-button style="margin: 0 20px" @click="printDialog = false"
              >取消</el-button
            >
          </div>
        </el-dialog>
        <el-dialog
          title="延迟"
          :visible.sync="delayDialog"
          width="60%"
          :before-close="closeDelayDialog"
          append-to-body
          :modal-append-to-body="false"
        >
          <avue-form
            v-if="delayDialog"
            :option="delayFormOption"
            v-model="delayForm"
            @submit="delayFormSubmit"
            @error="delayFormError"
          >
            <template slot="remark">
              <div>
                <el-input
                  type="textarea"
                  :rows="3"
                  maxlength="500"
                  show-word-limit
                  placeholder="请输入内容"
                  v-model="delayForm.remark"
                >
                </el-input>
                <remarkModel
                  :remark.sync="delayForm.remark"
                  ref="delayFormRemarkModel"
                ></remarkModel>
              </div>
            </template>
            <template slot="attachList">
              <vupload
                :fileList.sync="delayForm.attachList"
                :disabled="false"
                :showButton="true"
              ></vupload>
            </template>
            <template slot="menuForm">
              <el-button @click="closeDelayDialog"
                ><span class="el-icon-close"></span> 取消</el-button
              >
            </template>
          </avue-form>
        </el-dialog>
        <el-dialog
          title="恢复"
          :visible.sync="recoverDialog"
          width="60%"
          :before-close="closeRecoverDialog"
          append-to-body
          :modal-append-to-body="false"
        >
          <avue-form
            :option="recoverFormOption"
            v-model="recoverForm"
            v-if="recoverDialog"
            @submit="recoverFormSubmit"
            @error="recoverFormError"
          >
            <template slot="remark">
              <div>
                <el-input
                  type="textarea"
                  :rows="3"
                  maxlength="500"
                  show-word-limit
                  placeholder="请输入内容"
                  v-model="recoverForm.remark"
                >
                </el-input>
                <remarkModel
                  :remark.sync="recoverForm.remark"
                  ref="recoverFormRemarkModel"
                ></remarkModel>
              </div>
            </template>
            <template slot="menuForm">
              <el-button @click="closeRecoverDialog"
                ><span class="el-icon-close"></span> 取消</el-button
              >
            </template>
          </avue-form>
        </el-dialog>
        <el-dialog
          title="完成"
          :visible.sync="finishDialog"
          width="60%"
          :before-close="closeFinishDialog"
          append-to-body
          :modal-append-to-body="false"
        >
          <avue-form
            :option="finishFormOption"
            v-model="finishForm"
            v-if="finishDialog"
            @submit="finishFormSubmit"
            @error="finishFormError"
          >
            <template slot="remark">
              <div>
                <el-input
                  type="textarea"
                  :rows="3"
                  maxlength="500"
                  show-word-limit
                  placeholder="请输入内容"
                  v-model="finishForm.remark"
                >
                </el-input>
                <remarkModel
                  :remark.sync="finishForm.remark"
                  ref="finishFormRemarkModel"
                ></remarkModel>
              </div>
            </template>
            <template slot="attachList">
              <vupload
                :fileList.sync="finishForm.attachList"
                :disabled="false"
                :showButton="true"
              ></vupload>
            </template>
            <template slot="menuForm">
              <el-button @click="closeFinishDialog"
                ><span class="el-icon-close"></span> 取消</el-button
              >
            </template>
          </avue-form>
        </el-dialog>
        <el-dialog
          title="外委"
          :visible.sync="outsourcingDialog"
          width="60%"
          :before-close="closeOutsourcingDialog"
          append-to-body
          :modal-append-to-body="false"
        >
          <avue-form
            :option="outsourcingFormOption"
            v-model="outsourcingForm"
            v-if="outsourcingDialog"
            @submit="outsourcingFormSubmit"
            @error="outsourcingFormError"
          >
            <template slot="remark">
              <div>
                <el-input
                  type="textarea"
                  :rows="3"
                  maxlength="500"
                  show-word-limit
                  placeholder="请输入内容"
                  v-model="outsourcingForm.remark"
                >
                </el-input>
                <remarkModel
                  :remark.sync="outsourcingForm.remark"
                  ref="outsourcingFormRemarkModel"
                ></remarkModel>
              </div>
            </template>
            <template slot="menuForm">
              <el-button @click="closeOutsourcingDialog"
                ><span class="el-icon-close"></span> 取消</el-button
              >
            </template>
          </avue-form>
        </el-dialog>
        <el-dialog
          title="报废"
          :visible.sync="scrapDialog"
          width="60%"
          :before-close="closeScrapDialog"
          append-to-body
          :modal-append-to-body="false"
        >
          <avue-form
            :option="scrapFormOption"
            v-model="scrapForm"
            v-if="scrapDialog"
            @submit="scrapFormSubmit"
            @error="scrapFormError"
          >
            <template slot="remark">
              <div>
                <el-input
                  type="textarea"
                  :rows="3"
                  maxlength="500"
                  show-word-limit
                  placeholder="请输入内容"
                  v-model="scrapForm.remark"
                >
                </el-input>
                <remarkModel
                  :remark.sync="scrapForm.remark"
                  ref="scrapFormRemarkModel"
                ></remarkModel>
              </div>
            </template>
            <template slot="attachList">
              <vupload
                :fileList.sync="scrapForm.attachList"
                :disabled="false"
                :showButton="true"
              ></vupload>
            </template>
            <template slot="menuForm">
              <el-button @click="closeScrapDialog"
                ><span class="el-icon-close"></span> 取消</el-button
              >
            </template>
          </avue-form>
        </el-dialog>
        <el-dialog
          title="报修"
          :visible.sync="repairsDialog"
          width="60%"
          :before-close="closeRepairsDialog"
          append-to-body
          :modal-append-to-body="false"
        >
          <avue-form
            v-if="repairsDialog"
            :option="repairsFormOption"
            v-model="repairsForm"
            @submit="repairsFormSubmit"
            @error="repairsFormError"
          >
            <template slot="projectId">
              <el-select v-model="repairsForm.projectId" @change="changeHandler_">
                <el-option
                  v-for="(item, index) in projectList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
            <template slot="areaId">
              <el-select
                v-model="repairsForm.areaId"
                :value="repairsForm.areaId"
                placeholder="请选择需求区域"
                clearable
                ref="addConnectSelect"
              >
                <el-option
                  :value="repairsForm.areaId"
                  show-all-levels
                  :label="repairsForm.areaName"
                >
                  <el-tree
                    node-key="id"
                    :data="treeFormAreaData"
                    :props="treeProps"
                    :load="editAreaLazyLoadTree"
                    lazy
                    @node-click="editAreaNodeTreeClick_"
                  >
                  </el-tree>
                </el-option>
              </el-select>
            </template>
            <template slot="description">
              <div>
                <el-input
                  type="textarea"
                  :rows="3"
                  maxlength="500"
                  show-word-limit
                  placeholder="请输入内容"
                  v-model="repairsForm.description"
                >
                </el-input>
                <remarkModel
                  :remark.sync="repairsForm.description"
                  ref="repairsFormRemarkModel"
                ></remarkModel>
              </div>
            </template>
            <template slot="requireMainId">
              <el-select
                v-model="repairsForm.requireMainId"
                @change="changeRequireUserHandler_"
              >
                <el-option
                  v-for="(item, index) in requireUserList"
                  :key="index"
                  :label="item.realName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
            <template slot="attachList">
              <vupload
                :fileList.sync="repairsForm.attachList"
                :disabled="false"
                :showButton="true"
              ></vupload>
            </template>
            <template slot="menuForm">
              <el-button @click="closeRepairsDialog"
                ><span class="el-icon-close"></span> 取消</el-button
              >
            </template>
          </avue-form>
        </el-dialog>
      </div>

      <!-- <orderAudit></orderAudit> -->
    </el-dialog>
    <!-- <el-dialog
      title="详情"
      v-if="inspectTaskDialog"
      :visible.sync="inspectTaskDialog"
      width="60%"
      :before-close="closeRepairsDialog"
      append-to-body
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <add-inspection-record @cancelOperate="cancelOperate" @submitOver="submitOver" :isWatch="true" :isEdit="false" :projectId="projectId" :projectList='projectList' :form="detailForm"/>
     
    </el-dialog> -->
     <addInspectionRecord2 
                v-if="inspectTaskDialog"
                :dialogVisible.sync="inspectTaskDialog" 
                
                title="详情"
                operatorModel='view' 
                :projectId="projectId"
                :projectList='projectList'
                :row='detailRow'
                ></addInspectionRecord2>

    <el-dialog
      title="维修任务"
      :visible.sync="repairTaskDialog"
      width="60%"
      :before-close="closeRepairsDialog"
      append-to-body
      :modal-append-to-body="false"
    >
      <avue-form
        ref="repairTaskForm"
        v-if="repairTaskDialog"
        :option="repairTaskOption"
        v-model="repairTaskForm"
        @submit="repairTaskFormSubmit"
      >
        <template slot="deviceName">
          <div>
            <el-input type="text" v-model="repairTaskForm.deviceName" readonly />
          </div>
        </template>
        <template slot="standards" >
          <div>
            <!-- <div v-for="(item,index) in inspectTaskDetail.standards" :key="index" >
                            {{item.content}}
                        </div> -->
            <!-- {{scopes.column.disabled}} -->
            <el-button type="primary" @click="addDeviceConsumable">新增</el-button>
            <el-table :data="inspectTaskDetail.deviceConsumables" type="index">
              <el-table-column prop="name" label="名称">
                <template slot-scope="scope">
                  <!-- <el-input v-model="scope.row.name"></el-input> -->
                  <el-select
                    @change="changeDeviceConsumable(scope.row)"
                    v-model="scope.row.id"
                  >
                    <el-option
                      v-for="(item, index) in deviceConsumablesList"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="specification" label="规格">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.specification" disabled></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="count" label="数量">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.count"
                    maxlength="5"
                    @input="
                      scope.row['count'] = scope.row['count'].replace(/[^0-9_]/g, '')
                    "
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="price" label="金额">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.price" disabled></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" prop="errorFlag">
                <template slot-scope="scope">
                  <!-- <el-button @click="showTaskDetail(scope.row)">详情</el-button> -->
                  <!-- <el-radio-group v-model="scope.row.errorFlag" :disabled="scopes.column.disabled">
                                        <el-radio :label="0">正常</el-radio>
                                        <el-radio :label="1">异常</el-radio>
                                    </el-radio-group> -->
                  <el-button type="danger" @click="delDeviceConsumable(scope.row, scope)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>

        <template slot="serviceHour">
          <div>
            <el-input
              type="text"
              v-model="repairTaskForm.serviceHour"
              maxlength="5"
              @input="
                repairTaskForm.serviceHour = repairTaskForm.serviceHour.replace(
                  /[^0-9_]/g,
                  ''
                )
              "
            />
          </div>
        </template>
      </avue-form>
      <div style="text-align: center" v-if="!inspectTaskOption.column[0]['disabled']">
        <el-button @click="submitRepairForm">提交</el-button>
        <!-- <el-button @click="repairDevice">维修</el-button>
                <el-button @click="reportRepair">报修</el-button> -->
      </div>
    </el-dialog>

    <el-dialog
      title="维保任务"
      :visible.sync="upKeeperTaskDialog"
      width="60%"
      :before-close="closeRepairsDialog"
      append-to-body
      :modal-append-to-body="false"
    >
      <avue-form
        ref="upKeeperTaskForm"
        v-if="upKeeperTaskDialog"
        :option="upKeeperTaskOption"
        v-model="upKeeperTaskForm"
        @submit="upKeeperTaskFormSubmit"
      >
        <template slot="deviceName">
          <div>
            <el-input type="text" v-model="upKeeperTaskForm.deviceName" readonly />
          </div>
        </template>
        <template slot="standards">
          <div>
            <!-- <div v-for="(item,index) in inspectTaskDetail.standards" :key="index" >
                            {{item.content}}
                        </div> -->
            <!-- {{scopes.column.disabled}} -->
            <el-button type="primary" @click="addDeviceConsumable">新增</el-button>
            <el-table :data="inspectTaskDetail.deviceConsumables" type="index">
              <el-table-column prop="name" label="名称">
                <template slot-scope="scope">
                  <!-- <el-input v-model="scope.row.name"></el-input> -->
                  <el-select
                    @change="changeDeviceConsumable(scope.row)"
                    v-model="scope.row.id"
                  >
                    <el-option
                      v-for="(item, index) in deviceConsumablesList"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="specification" label="规格">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.specification" disabled></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="count" label="数量">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.count"
                    maxlength="5"
                    @input="
                      scope.row['count'] = scope.row['count'].replace(/[^0-9_]/g, '')
                    "
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="price" label="金额">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.price" disabled></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" prop="errorFlag">
                <template slot-scope="scope">
                  <!-- <el-button @click="showTaskDetail(scope.row)">详情</el-button> -->
                  <!-- <el-radio-group v-model="scope.row.errorFlag" :disabled="scopes.column.disabled">
                                        <el-radio :label="0">正常</el-radio>
                                        <el-radio :label="1">异常</el-radio>
                                    </el-radio-group> -->
                  <el-button type="danger" @click="delDeviceConsumable(scope.row, scope)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>

        <template slot="serviceHour">
          <div>
            <el-input
              type="text"
              v-model="upKeeperTaskForm.serviceHour"
              maxlength="5"
              @input="
                upKeeperTaskForm.serviceHour = upKeeperTaskForm.serviceHour.replace(
                  /[^0-9_]/g,
                  ''
                )
              "
            />
          </div>
        </template>
      </avue-form>
      <div style="text-align: center" v-if="!inspectTaskOption.column[0]['disabled']">
        <el-button @click="submitUpKeeperForm">提交</el-button>
        <!-- <el-button @click="repairDevice">维修</el-button>
                <el-button @click="reportRepair">报修</el-button> -->
      </div>
    </el-dialog>

    <actionForm @handleClose="handleClose" ref="settingSynergy"></actionForm>
    <comfirmForm @handleClose="handleClose" ref="comfirmForm"></comfirmForm>
    <visitForm @handleClose="handleClose" ref="visitForm"></visitForm>

    <!-- 开始 -->
    <Start @handleClose="handleClose" ref="start"></Start>
    <!-- 完成 -->
    <Finish @handleClose="handleClose" ref="finish"></Finish>
    <!-- 外委 -->
    <Outsourcing @handleClose="handleClose" ref="Outsourcing"></Outsourcing>
    <!-- 转办 -->
    <Complaint @handleClose="handleClose" ref="complaint" />
     <!-- 派单 -->
    <Appoint @handleClose="handleClose" ref="Appoint"></Appoint>
    <!-- 抢单 -->
    <GrabSingle @handleClose="handleClose" ref="GrabSingle"></GrabSingle>
    <!-- 取消 -->
    <Cencel @handleClose="handleClose" ref="cencel"></Cencel>
    
    <!-- 接收 -->
    <Receive @handleClose="handleClose" ref="Receive"></Receive>

    <!-- 报废 -->
    <Scrap @handleClose="handleClose" ref="Scrap"></Scrap>
    <!-- 挂起、延迟 -->
    <Delay @handleClose="handleClose" ref="Delay"></Delay>

    <!-- 恢复 -->
    <Recover @handleClose="handleClose" ref="Recover"></Recover>

    <!-- 评价 -->
    <Evaluate @handleClose="handleClose" ref="Evaluate"></Evaluate>
    <!-- 催办 -->
    <urgeForm @handleClose="handleClose" ref="urgeForm"></urgeForm>
  </div>
</template>
<script>
import {
  complaintFormOption,
  assignFormOption,
  robOrderFormOption,
  startOrderFormOption,
  cancelFormOption,
  evaluateFormOption,
  visitFormOption,
  delayFormOption,
  recoverFormOption,
  finishFormOption,
  scrapFormOption,
  repairsFormOption,
  outsourcingFormOption,
} from "./course-dialog-form-option";

import orderAudit from "../actionButton-dialog/order-audit";
import addInspectionRecord from '@/components/device/deviceInspectionRecord/deviceInspectionRecord.vue';
import vupload from "@/views/components/v-upload";
import actionForm from "./course-action-form";
import comfirmForm from "../actionForm/confirm";
import visitForm from "../actionForm/visit";
import Complaint from "../actionForm/complaint";
import Appoint from "../components/appoint";
import GrabSingle from "../components/grabSingle";
import addInspectionRecord2 from "@/components/device/deviceInspectionRecord/deviceInspect.vue"
import {
  getList,
  getprojectList,
  getOrderactionlist,
  getCourseLog,
  getOrderDetail,
  getDictData,
  getGroupName, //获取班组名称以及id
  getMenberUserList, //获取群组下的人员
  lazyAreaTree, //懒加载区域树
  getUserListByDepartmentId, //报单人员
  appoint, //指派
  grabSingle, //抢单
  cancel, //工单取消
  print, //工单打印
  accept, //工单接受
  start, //工单开始
  delay, //工单延迟
  recover, //工单恢复
  finish, //工单完成
  evaluation, //工单评价
  repairs, //工单报修
  scrap, //工单报废
  outsourcing, //工单外委
  getGroupList, //获取班组列表
  complaint, //转办
  getRemarkList, //获取备注模板
  downloadFile, //下载文件方法
  getGroupDetails,
  getDetailByOrderId,
  getTaskListByOrderAndDevice,
  commitTaskList,
  getConsumableList,
  addRepair,
} from "@/api/crmedical/order/order-list/order-list";
import { getProjectDict } from "@/api/crmedical/project-dictionary/project-dictionary";
import remarkModel from "./remark-model";
import { mapGetters } from "vuex";
import Outsourcing from "../actionForm/outsourcing.vue";
import func from "../../../../util/func";
import { watchInspectRecordRecord} from '@/api/crmedical/device/deviceInspectionStandard'
import Receive from "../components/receive.vue"
import Cencel from "../components/cencel.vue";
import Scrap from "../components/scrap.vue";
import Delay from "../components/delay.vue";
import Recover from "../components/recover.vue";
import Evaluate from "../components/evaluation.vue"
import Start from "../equipment-inspection/start";
import Finish from "../equipment-inspection/end";
import urgeForm from "../actionForm/urge";
export default {
  components: {
    addInspectionRecord2,
    Start,
    Finish,
    addInspectionRecord,
    vupload,
    remarkModel,
    actionForm,
    comfirmForm,
    visitForm,
    Outsourcing,
    Complaint,
    Appoint,
    GrabSingle,
    Cencel,
    Receive,
    Scrap,
    Delay,
    Recover,
    Evaluate,
    urgeForm
  },
  data() {
    return {
      detailRow:{},
      dialogBodyHight:0,
      dialogFull:false,
      dialogBodyHight:0,
      dialogFull:false,
      detailForm:{},//详情的数据集
      evaluateTypeList:[],
      evaluateDetailList:[],
      evaluateInfo:{},
      upKeeperTaskOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            type: "input",
            label: "设施设备",
            span: 8,
            display: true,
            formslot: true,
            prop: "deviceName",
            required: true,
            rules: [{ required: true, message: "请填写设施设备" }],
            readonly: false,
            disabled: true,
          },
          {
            type: "input",
            label: "耗材",
            span: 24,
            formslot: true,
            display: true,
            prop: "standards",
            // required: true,
            // rules:[ { required: true,}],
            readonly: false,
          },
          {
            type: "textarea",
            label: "备注",
            span: 24,
            display: true,
            placeholder: "填写备注",
            prop: "remark",
            required: true,
            rules: [{ required: true, message: "请填写备注" }],
            readonly: false,
          },

          {
            type: "input",
            label: "维修工时",
            span: 24,
            display: true,
            placeholder: "填写维修工时",
            prop: "serviceHour",
            formslot: true,
            required: true,
            rules: [{ required: true, message: "请填写维修工时" }],
            readonly: false,
          },
          {
            label: "系统背景",
            prop: "imgIds",
            type: "upload",
            listType: "picture-img",
            action: "/api/v4ward/oss/customEndpoint/put-file",
            propsHttp: {
              res: "data",
              url: "link",
            },
            multiple: true,
            hide: true,
            span: 24,
          },
        ],
      },
      repairTaskOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            type: "input",
            label: "设施设备",
            span: 8,
            display: true,
            formslot: true,
            prop: "deviceName",
            required: true,
            rules: [{ required: true, message: "请填写设施设备" }],
            readonly: false,
            disabled: true,
          },
          {
            type: "input",
            label: "耗材",
            span: 24,
            formslot: true,
            display: true,
            prop: "standards",
            // required: true,
            // rules:[ { required: true,}],
            readonly: false,
          },
          {
            type: "textarea",
            label: "备注",
            span: 24,
            display: true,
            placeholder: "填写备注",
            prop: "remark",
            required: true,
            rules: [{ required: true, message: "请填写备注" }],
            readonly: false,
          },

          {
            type: "input",
            label: "维修工时(小时)",
            span: 24,
            display: true,
            placeholder: "填写维修工时",
            prop: "serviceHour",
            formslot: true,
            required: true,
            rules: [{ required: true, message: "请填写维修工时" }],
            readonly: false,
          },
          {
            label: "系统背景",
            prop: "imgIds",
            type: "upload",
            listType: "picture-img",
            action: "/api/v4ward/oss/customEndpoint/put-file",
            propsHttp: {
              res: "data",
              url: "link",
            },
            multiple: true,
            hide: true,
            span: 24,
          },
        ],
      },
      inspectTaskOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            type: "input",
            label: "设施设备",
            span: 8,
            display: true,
            formslot: true,
            prop: "deviceName",
            required: true,
            rules: [{ required: true }],
            readonly: false,
            disabled: true,
          },
          {
            type: "input",
            label: "巡检项列表",
            span: 24,
            formslot: true,
            display: true,
            prop: "standards",
            // required: true,
            // rules:[ { required: true,}],
            readonly: false,
          },
          {
            type: "textarea",
            label: "备注",
            span: 24,
            display: true,
            placeholder: "填写备注",
            prop: "remark",
            required: true,
            rules: [{ required: true }],
            readonly: false,
          },
          {
            label: "系统背景",
            prop: "imgIds",
            type: "upload",
            listType: "picture-img",
            action: "/api/v4ward/oss/customEndpoint/put-file",
            propsHttp: {
              res: "data",
              url: "link",
            },
            multiple: true,
            hide: true,
            span: 24,
          },
        ],
      },
      repairTaskDialog: false,
      upKeeperTaskDialog: false,
      // upKeeperTaskForm
      inspectTaskDialog: false,
      inspectTaskFlag: false,
      taskListData: [],
      loading: 0,
      evaluateList: [], //评价表单  --评价对象list
      treeProps: {
        //报修表单 --需求区域树的配置
        //标题
        label: "name",
        //值
        value: "id",
        //子节点
        children: "zones",
        //是否叶子节点
        isLeaf: "hasChildren",
        //本节点类型key值
        objectType: "id",
        //本节点类型名
        objectTypeName: "name",
      },
      requireUserList: [], //报修表单 --报单人员
      treeFormAreaData: [], //懒加载区域树 --报修表单中
      printLoading: true, //打印加载状态开关
      test: false,
      courseList: [], //获取历程数据
      dialogVisible: false,
      imgUrlData: [], //图片的容器
      fileUrlData: [], //文件的容器
      orderDetailForm: {
        name: "",
      }, //工单详情
      complaintForm: {
        name: "",
      },
      orderId: "", //工单id
      projectId: "", //项目id
      moduleType: "", //来电类型
      // 表单配置
      delayFormOption: delayFormOption, //延迟

      recoverFormOption: recoverFormOption, //恢复

      finishFormOption: finishFormOption, //完成

      outsourcingFormOption: outsourcingFormOption, //外委

      scrapFormOption: scrapFormOption, //报废

      repairsFormOption: repairsFormOption, //报修

      complaintFormOption: complaintFormOption,

      assignFormOption: assignFormOption,

      robOrderFormOption: robOrderFormOption,

      startOrderFormOption: startOrderFormOption,

      cancelFormOption: cancelFormOption,

      evaluateFormOption: evaluateFormOption,

      visitFormOption: visitFormOption,
      delayForm: {
        attachList: [],
      },
      recoverForm: {},
      finishForm: {
        attachList: [],
      },
      outsourcingForm: {},
      scrapForm: {
        attachList: [],
      },
      repairsForm: {
        attachList: [],
      },
      complaintForm: {},
      assignForm: {},
      robOrderForm: {},
      startOrderForm: {
        attachList: [],
      },
      cancelForm: {
        attachList: [],
      },
      evaluateForm: {},
      visitForm: {},
      printForm: {},
      // 弹窗控制d
      delayDialog: false, //延迟
      recoverDialog: false, //恢复
      finishDialog: false, //完成
      scrapDialog: false, //报废
      outsourcingDialog: false, //外委
      repairsDialog: false, //报修
      complaintDialog: false,
      assignDialog: false,
      robOrderDialog: false,
      startOrderDialog: false,
      cancelDialog: false,
      evaluateDialog: false,
      visitDialog: false,
      receiveDialog: false,
      printDialog: false,
      orderActiveButton: [], //按钮
      orderStatusNameList: [], //工单状态
      groupList: [], //取组下拉框
      orderRequireSourcelist: [], //需求来源列表
      obj: {
        dynamic: [
          {
            input: 1,
            select: 1,
            radio: 1,
          },
          {
            input: 2,
            select: 2,
            radio: 1,
          },
        ],
      },
      option: {
        column: [],
        labelPosition: "right",
        labelSuffix: "：",
        labelWidth: 100,
        gutter: 0,
        menuBtn: false,
        submitBtn: false,
        submitText: "提交",
        emptyBtn: true,
        emptyText: "清空",
        menuPosition: "center",
        // disabled: true,

        group: [
          {
            label: "需求信息",
            prop: "1604911406120_70101",
            arrow: true,
            collapse: true,
            display: true,
            column: [
              {
                type: "select",
                label: "项目名称",
                span: 8,
                rules: [{ required: true }],
                display: true,
                prop: "projectId",
                dicUrl: "/api/v4ward/project/getProjectList",
                props: { label: "name", value: "id" },
                disabled: true,
                required: true,
              },
              {
                type: "input",
                label: "业务类型",
                span: 8,
                display: true,
                prop: "subModuleName",
                disabled: true,
                required: true,
              },
              {
                type: "select",
                label: "报单人",
                span: 8,
                display: true,
                rules: [{ required: true }],
                prop: "requireManName",
                required: true,
                disabled: true,
              },
              {
                type: "select",
                label: "上级单位",
                span: 8,
                rules: [{ required: true }],
                display: true,
                prop: "requireDeptName",
                disabled: true,
              },
              {
                type: "input",
                label: "项目地点",
                span: 8,
                display: false,
                prop: "areaName",
                readonly: false,
                disabled: true,
              },
              {
                type: "datetime",
                label: "期望解决时间",
                labelWidth: 120,
                span: 8,
                display: true,
                prop: "expectStartTime",
                required: true,
                rules: [{ required: true }],
                format: "yyyy-MM-dd HH:mm:ss",
                valueFormat: "yyyy-MM-dd HH:mm:ss",
                disabled: true,
              },
              {
                type: "input",
                label: "需求来源",
                span: 8,
                // rules:[ { required: true,}],
                display: true,
                dataType: "string",
                // dicUrl:'/api/blade-system/dict/dictionary?code=order_require_source',
                props: {
                  label: "dictValue",
                  value: "dictKet",
                },
                prop: "sourceName",
                required: true,
                disabled: true,
              },
              {
                type: "textarea",
                label: "需求描述",
                span: 24,
                rules: [{ required: true }],
                display: true,
                prop: "description",
                required: true,
                disabled: true,
              },
              {
                type: "input",
                label: "关键词",
                span: 8,
                rules: [{ required: true }],
                display: true,
                prop: "keyWords",
                required: true,
                disabled: true,
              },
              {
                type: "input",
                label: "需求附件",
                span: 24,
                // rules: [{ required: true }],
                display: true,
                formslot: true,
                typeslot: true,
                prop: "attachList",
                // required: true,
                disabled: true,
              },
              // {
              //     type: 'input',
              //     label: '项目地点',
              //     span: 8,
              //     display: true,
              //     prop: 'areaName',
              //     required: true,
              //     rules:[ { required: true,}],
              //     readonly: false,
              //     disabled: true
              // },
              {
                // type: 'input',
                // label: '需求附件',
                // span: 24,
                // rules:[ { required: true,}],
                // display: true,
                // formslot:true,
                // typeslot: true,
                // prop: 'attachList',
                // required: true,
                // disabled: true

                type: "input",
                label: "巡检任务1",
                span: 24,
                prop: "inspectTaskList",
                display: true,
                formslot: true,
                typeslot: true,
              },
              {
                label: "评价信息",
                prop: "evaluate",
                formslot:true,
              }
            ],
          },
        ],
      },
      requestDictionaryFlag: 0,
      inspectTaskDetail: {},
      inspectTaskForm: {},
      repairTaskForm: {},
      upKeeperTaskForm: {},
      orderRow:{},//包含所有的基础信息
    };
  },  created() {
    //this.getDictionary();
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {
    'orderDetailForm.areaName': {
      handler(val) {
        console.log(val)
        this.handlerHide(val);
      },
      immediate: true,
    },
  },
  mounted(){
            this.dialogFull = false;
            let bodyHight = document.body.clientHeight;

            this.dialogBodyHight = bodyHight - 330;

  },
  methods: {
    // 打开验收确认弹窗
    openUrgeDialog() {
      console.log("打开确认");
      this.$refs.urgeForm.openDialog(this.orderId);
    },
    cancelOperate(){
       this.inspectTaskDialog = false;
    },
        // 根据评价显示评价等级
        tag(level){
            let tag = '';
            if(level==2){
                tag="差";
            }else if(level==3){
                tag="一般";
            }else if(level==4){
                tag="好";
            }else if(level==5){
                tag="非常好";
            }else if(level==1){
                tag="很差";
            }else if(level==0){
                tag="";
            }
            return tag;
        },
    getEvaluateType(type){
      let name = '';
      this.evaluateTypeList.forEach((ele,index)=>{
        if(ele.dictKey === type){
          name = ele.dictValue;
        }
      });
      return name;
    },
    handlerHide(val){
      var areaName = this.findObject(this.option.group[0].column, 'areaName');
      if(func.isEmpty(val)){
        areaName.display = false;
        areaName.rules = [];
      }else {
        areaName.display = true;
        areaName.rules = [
          {
            required: true,
            message: '请输入项目地点',
            trigger: 'blur',
          },
        ];
      }
    },
    handleAddReportRepair() {
      this.$emit("addReportRepair", this.inspectTaskForm.deviceId);
    },
    submitInspectForm() {
      this.$refs.inspectTaskForm.form.standards = this.inspectTaskDetail.standards;
      this.$refs.inspectTaskForm.form.taskId = this.inspectTaskDetail.taskId;
      this.$refs.inspectTaskForm.form.taskListId = this.inspectTaskDetail.taskListId;
      this.$refs.inspectTaskForm.form.orderId = this.orderId;
      this.$refs.inspectTaskForm.form.errorFlag = 0;
      this.inspectTaskDetail.standards.forEach((ele, index) => {
        if (parseInt(ele.errorFlag) > 0) {
          this.$refs.inspectTaskForm.form.errorFlag = ele.errorFlag;
        }
      });
      console.log(this.$refs.inspectTaskForm.form);

      this.$refs["inspectTaskForm"].validate((valid) => {
        if (valid) {
          // alert('submit!');
          // return;
          commitTaskList(this.$refs.inspectTaskForm.form).then((res) => {
            this.inspectTaskDialog = false;

            getOrderDetail(this.orderId).then((res) => {
              this.taskListData = res.data.orderDetails[0].businessData;
              this.taskListData = this.deepClone(this.taskListData);
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addDeviceConsumable() {
      this.inspectTaskDetail.deviceConsumables.push({
        id: "",
        name: "",
        price: "",
        count: "",
      });
      this.inspectTaskDetail = this.deepClone(this.inspectTaskDetail);
    },
    delDeviceConsumable(row, scope) {
      this.inspectTaskDetail.deviceConsumables.splice(scope.$index, 1);
      console.log(row, scope);
      this.inspectTaskDetail = this.deepClone(this.inspectTaskDetail);
    },
    repairDevice() {
      // this.$refs.addRepairDeviceOrder.openDialog();
      this.repairTaskDialog = true;
      this.repairTaskForm = {};
      this.repairTaskForm.deviceName = this.inspectTaskForm.deviceName;
      getConsumableList({ projectId: this.projectId }).then((res) => {
        console.log(res);
        this.deviceConsumablesList = res.data;
        // this.inspectTaskDetail.deviceConsumables = res.data;
        this.inspectTaskDetail.deviceConsumables = [];
        this.inspectTaskDetail = this.deepClone(this.inspectTaskDetail);
      });
    },
    changeDeviceConsumable(row) {
      console.log("changeDeviceConsumable", row);
      this.deviceConsumablesList.forEach((ele, index) => {
        if (ele.id === row.id) {
          row.name = ele.name;
          row.price = ele.price;
          row.specification = ele.specification;
          row.count = 0;
        }
      });
    },
    submitRepairForm() {
      let arrList = [];
      let totalAmount = 0;
      this.inspectTaskDetail.deviceConsumables.forEach((ele, index) => {
        if (ele.id) {
          arrList.push({
            consumableId: ele.id,
            consumeNum: ele.count,
          });
          totalAmount += parseInt(ele.count) * parseFloat(ele.price);
          // this.inspectTaskDetail.deviceConsumables[index] = {
          //     consumableId:ele.id
          //     // consumeNum:
          // }
        }
      });
      this.$refs.repairTaskForm.form.deviceId = this.inspectTaskForm.deviceId;

      this.$refs.repairTaskForm.form.amount = totalAmount.toFixed(2);
      // this.$refs.repairTaskForm.form.consumables = this.inspectTaskDetail.deviceConsumables;
      this.$refs.repairTaskForm.form.consumables = arrList;
      this.$refs.repairTaskForm.form.taskId = this.inspectTaskDetail.taskId;
      this.$refs.repairTaskForm.form.taskListId = this.inspectTaskDetail.taskListId;
      this.$refs.repairTaskForm.form.orderId = this.orderId;
      // this.$refs.repairTaskForm.form.errorFlag = 0;
      // this.inspectTaskDetail.standards.forEach((ele,index)=>{
      //     if(parseInt(ele.errorFlag)>0){
      //         this.$refs.repairTaskForm.form.errorFlag = ele.errorFlag;
      //     }
      // });
      console.log(this.$refs.repairTaskForm.form);

      if (
        !this.$refs.repairTaskForm.form.consumables ||
        this.$refs.repairTaskForm.form.consumables.length == 0
      ) {
        this.$message.error("请选择耗材!");
        return;
      }

      this.$refs["repairTaskForm"].validate((valid) => {
        if (valid) {
          // alert('submit!');
          // return;
          addRepair(this.$refs.repairTaskForm.form).then((res) => {
            this.$message.success("操作成功!");
            this.repairTaskDialog = false;

            getOrderDetail(this.orderId).then((res) => {
              this.taskListData = res.data.orderDetails[0].businessData;
              this.taskListData = this.deepClone(this.taskListData);
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    reportRepair() {
      // this.$refs.addRepairDeviceOrder.openDialog();
      this.upKeeperTaskDialog = true;
      this.upKeeperTaskForm.deviceName = this.inspectTaskForm.deviceName;
      getConsumableList({ projectId: this.projectId }).then((res) => {
        console.log(res);
        this.deviceConsumablesList = res.data;
        // this.inspectTaskDetail.deviceConsumables = res.data;
        this.inspectTaskDetail.deviceConsumables = [];
        this.inspectTaskDetail = this.deepClone(this.inspectTaskDetail);
      });
    },

    submitUpKeeperForm() {
      let arrList = [];
      let totalAmount = 0;
      this.inspectTaskDetail.deviceConsumables.forEach((ele, index) => {
        if (ele.id) {
          arrList.push({
            consumableId: ele.id,
            consumeNum: ele.count,
          });
          totalAmount += parseInt(ele.count) * parseFloat(ele.price);
          // this.inspectTaskDetail.deviceConsumables[index] = {
          //     consumableId:ele.id
          //     // consumeNum:
          // }
        }
      });
      this.$refs.upKeeperTaskForm.form.deviceId = this.inspectTaskForm.deviceId;

      this.$refs.upKeeperTaskForm.form.amount = totalAmount.toFixed(2);
      // this.$refs.upKeeperTaskForm.form.consumables = this.inspectTaskDetail.deviceConsumables;
      this.$refs.upKeeperTaskForm.form.consumables = arrList;
      this.$refs.upKeeperTaskForm.form.taskId = this.inspectTaskDetail.taskId;
      this.$refs.upKeeperTaskForm.form.taskListId = this.inspectTaskDetail.taskListId;
      this.$refs.upKeeperTaskForm.form.orderId = this.orderId;
      // this.$refs.upKeeperTaskForm.form.errorFlag = 0;
      // this.inspectTaskDetail.standards.forEach((ele,index)=>{
      //     if(parseInt(ele.errorFlag)>0){
      //         this.$refs.upKeeperTaskForm.form.errorFlag = ele.errorFlag;
      //     }
      // });
      console.log(this.$refs.upKeeperTaskForm.form);

      this.$refs["upKeeperTaskForm"].validate((valid) => {
        if (valid) {
          // alert('submit!');
          // return;
          addRepair(this.$refs.upKeeperTaskForm.form).then((res) => {
            this.repairTaskDialog = false;

            getOrderDetail(this.orderId).then((res) => {
              this.taskListData = res.data.orderDetails[0].businessData;
              this.taskListData = this.deepClone(this.taskListData);
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // reportRepair(){
    //     // this.$refs.addReportRepairOrder.openDialog();
    //     this.inspectTaskDialog = false;
    //     this.repairTaskDialog = false;
    //     // this.handleClose(()=>{console.log('closeAction');});
    //     setTimeout(()=>{
    //         document.querySelector('div[class="el-dialog__wrapper"]').click();
    //         setTimeout(()=>{
    //             document.querySelector('div[class="el-dialog__wrapper"]').click();
    //         });
    //     });
    //     this.$router.push({path: "/crmedical/order/order?add=reportRepair"});
    // },
    // showRepairDetail(){
    //     this.repairTaskDialog = true;
    // },
    showTaskDetail(row, column, event) {
      // console.log("66666");
      // console.log(row, column, event);
      this.detailForm = {}
      this.inspectTaskForm.deviceId = row.deviceId;
      this.inspectTaskForm.deviceName = row.deviceName;
      
      this.detailRow = row
      this.detailRow.id = this.detailRow.taskListId
      console.log('row---', this.detailRow)
      this.inspectTaskDialog = true;
      // watchInspectRecordRecord({id:row.taskListId}).then(res =>{
      //   this.detailForm = res.data
      //   this.inspectTaskDialog = true;
      // })
      // getTaskListByOrderAndDevice({ taskListId: row.taskListId, deviceId: row.deviceId }).then(
      //   (res) => {
      //     console.log(res);
      //     this.inspectTaskDetail = res.data;
      //     this.detailForm = res.data;
      //     console.log("巡检详情的值",this.detailForm)
      //     if (row.realInspectManId) {
      //       // this.inspectTaskOption.submitBtn = false;
      //       // this.inspectTaskOption.emptyBtn = false;
      //       this.inspectTaskOption.column.forEach((ele, index) => {
      //         this.inspectTaskOption.column[index].disabled = true;
      //       });
      //     } else {
      //       // this.inspectTaskOption.submitBtn = true;
      //       // this.inspectTaskOption.emptyBtn = true;
      //       this.inspectTaskOption.column.forEach((ele, index) => {
      //         this.inspectTaskOption.column[index].disabled = false;
      //       });
      //     }
      //     if (this.workStatus != 4 && !row.requireMainId) {
      //       this.inspectTaskOption.disabled = true;
      //     } else {
      //       this.inspectTaskOption.disabled = false;
      //     }
      //     this.inspectTaskDialog = true;
      //   }
      // );
    },
    getErrorFlag(val) {
      if (parseInt(val) == 1) {
        return "有异常";
      } else {
        return "无异常";
      }
    },
    // 打开验收确认弹窗
    openConfirmDialog() {
      console.log("打开确认");
      this.$refs.comfirmForm.openDialog(this.orderId);
    },
    // 打开设置协同人框
    opensettingSynergy() {
      this.$refs.settingSynergy.openDialog(this.orderId);
    },
    // 打开回访
    openVisitDialog() {
      this.$refs.visitForm.openDialog(this.orderId, this.projectId);
    },
    // 打开弹窗获取数据
    openDialog(row, type = "list") {
      let id = row.id
      this.orderRow = row
      this.loading = 0;
      this.orderId = id;
      // 获取按钮
      if (type == "list") {
        getOrderactionlist({ id: id }).then((res) => {
          this.orderActiveButton = res.data;
        });
      }

      // 获取工单详情
      if (this.requestDictionaryFlag >= 60) {
        this.getOrderDetail(id);
      }

      // 获取历程数据
      getDictData("order_operate_type").then((res) => {
        console.log(res);
        this.orderActionList = res.data;
        getCourseLog(id).then((res) => {
          res.data.forEach((ele) => {
            ele.orderActionName = this.tool.getDictionaryValue(
              this.orderActionList,
              "dictValue",
              "dictKey",
              ele.operateType
            );
            ele.fileList = [];
            ele.imgUrlData = [];
            ele.showDetail = false;
            ele.attachList.forEach((item) => {
              if (
                item.link.substring(item.link.length - 3) == "png" ||
                item.link.substring(item.link.length - 3) == "jpg"
              ) {
                ele.imgUrlData.push(item);
              } else {
                ele.fileList.push(item);
              }
            });
            this.loading += 20;
          });
          this.courseList = res.data;
        });
      });
      this.dialogVisible = true;
    },
    // 获取工单详情
    getOrderDetail(orderId) {
      this.loading = 30;
      // getDetailByOrderId(orderId).then(res=>{
      //     console.log(res);
      // })
      getOrderDetail(orderId).then((res) => {
        this.taskListData = res.data.orderDetails[0].businessData;
        // this.orderActiveButton = res.data.actionType;
        this.orderDetailForm = res.data.orderDetails[0];
        this.projectId = this.orderDetailForm.projectId;
        this.orderDetailForm.fileList = [];
        this.orderDetailForm.imgUrlData = [];
        this.moduleType = this.orderDetailForm.moduleType;
        this.orderDetailForm.attachList.forEach((item) => {
          if (
            item.link.substring(item.link.length - 3) == "png" ||
            item.link.substring(item.link.length - 3) == "jpg"
          ) {
            this.orderDetailForm.imgUrlData.push(item);
          } else {
            this.orderDetailForm.fileList.push(item);
          }
        });
        console.log(this.orderDetailForm.imgUrlData);
        console.log(this.orderDetailForm.fileList);
        this.loading += 20;
        console.log(res.data.dictList);
        this.orderDetailForm.moduleTypeName = this.tool.getDictionaryValue(
          this.moduleTypeList,
          "dictValue",
          "dictKey",
          this.orderDetailForm.moduleType
        );

        this.orderDetailForm.sourceName = this.tool.getDictionaryValue(
          this.orderRequireSourcelist,
          "dictValue",
          "dictKey",
          this.orderDetailForm.source
        );
         if(this.orderDetailForm.requireMainPhone){ //如果有电话号码需要将电话号码拼接在姓名后面
          this.orderDetailForm.requireManName = this.orderDetailForm.requireManName + ' ('+ this.orderDetailForm.requireMainPhone +')';
        }

        this.orderDetailForm.statusName = this.tool.getDictionaryValue(
          this.orderStatusNameList,
          "dictValue",
          "dictKey",
          this.orderDetailForm.workStatus
        );

        this.evaluateInfo = res.data.evaluate;
        this.evaluateDetailList = res.data.evaluate.detailList;
        console.log('this.evaluateInfo=================>',this.evaluateInfo);
        console.log('this.evaluateDetailList=================>',this.evaluateDetailList);

        getProjectDict({projectId:this.projectId,code:'project_order_evaluate_target'}).then((res) => {
          console.log(res.data);
          this.evaluateTypeList = res.data;
        });
      });
    },
    // 点击历程上的详情
    clickDetail(item) {
      this.$set(item, "showDetail", !item.showDetail);
      let list = this.courseList;
      this.courseList = 12312;
      this.courseList = list;
    },
    // 获取各种字典
    async getDictionary() {
      // 获取项目
      await getprojectList().then((res) => {
        this.projectList = res.data;
        this.requestDictionaryFlag += 20;
        // if(this.requestDictionaryFlag>=60){
        //     this.getOrderDetail();
        //  }
      });
      // 获取来电类型
      await getDictData("module_type").then((res) => {
        this.moduleTypeList = res.data;
        this.requestDictionaryFlag += 20;
      });
      // order_work_status 获取工单状态
      await getDictData("order_work_status").then((res) => {
        this.orderStatusNameList = res.data;
        this.requestDictionaryFlag += 20;
      });
      // order_require_source 获取需求来源
      await getDictData("order_require_source").then((res) => {
        this.orderRequireSourcelist = res.data;
        this.requestDictionaryFlag += 20;
      });
    },
    // 下载文件接口
    downloadFile(file) {
      // data 是接口地址
      downloadFile(file.link, file.originalName);
    },
    handleClose(done) {
      console.log(212222)
      // 关闭大弹窗
      this.dialogVisible = false;
      this.visitDialog = false;
      // 调用外层刷新功能
      this.$emit("refresh");

      // 清空按钮表单
      this.delayForm = {
        attachList: [],
      };
      this.recoverForm = {};
      this.finishForm = {
        attachList: [],
      };
      this.outsourcingForm = {};
      this.scrapForm = {
        attachList: [],
      };
      this.complaintForm = {};
      this.assignForm = {};
      this.robOrderForm = {};
      this.startOrderForm = {
        attachList: [],
      };
      this.cancelForm = {
        attachList: [],
      };
      this.repairsForm = {
        attachList: [],
      };
      this.evaluateForm = {};
      this.visitForm = {};
      this.printForm = {};

      // 关闭按钮弹窗
      (this.delayDialog = false), //延迟
        (this.recoverDialog = false), //恢复
        (this.finishDialog = false), //完成
        (this.scrapDialog = false), //报废
        (this.outsourcingDialog = false), //外委
        (this.repairsDialog = false), //报修
        (this.complaintDialog = false), //转办
        (this.assignDialog = false), //指派
        (this.robOrderDialog = false), //抢单
        (this.startOrderDialog = false), //开始
        (this.cancelDialog = false), //取消
        (this.evaluateDialog = false), //评价
        (this.visitDialog = false), //回访
        (this.printDialog = false), //打印
        done();
    },
    // 打印弹窗
    openPrintDialog() {
      (this.printLoading = true), (this.printDialog = true);
      print({ orderId: this.orderId }).then((res) => {
        this.printForm = res.data;
        this.printLoading = false;
      });
    },
    // 打印确认
    printSubmit() {
      setTimeout(() => {
        this.$Print({
          id: "print",
          html: document.getElementById("print").innerHTML,
        });
        this.printDialog = false;
      }, 100);
    },
    // 关闭打印预览弹窗
    closePrintDialog(done) {
      done();
    },

    // 评价弹窗
    openEvaluateDialog(title) {
      this.$refs.Evaluate.openDialog({orderId:this.orderId,title:title,projectId:this.projectId});
    },
    // 评价提交
    evaluateFormSubmit(form, done) {
      console.log(form);
      form.detailList = [];
      this.evaluateFormOption.column.forEach((ele) => {
        if (ele.prop != "content" && ele.prop != "attachList") {
          let temObj = { target: ele.prop, level: form[ele.prop] };
          form.detailList.push(temObj);
        }
      });
      if (form.detailList.length == 0) {
        this.$message({
          message: "缺少打分项",
          type: "warning",
        });
        done();
        return;
      }
      let contentFlag = false;
      for (let i = 0; i < this.evaluateList.length; i++) {
        if (!form.detailList[i].level) {
          this.$message({
            message: `请评价${this.evaluateFormOption.column[i].label}`,
            type: "warning",
          });
          done();
          return;
        }

        if (form[this.evaluateList[i].dictKey] < 3) {
          contentFlag = true;
          break;
        }
      }
      if (contentFlag) {
        if (!form.content) {
          this.$message({
            message: "请填写差评信息",
            type: "warning",
          });
          done();
          return;
        }
      }

      form.orderId = this.orderId;
      // return;
      form.remark = form.content;
      evaluation(form)
        .then((res) => {
          if (res.msg == "操作成功") {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.dialogVisible = false;
            this.evaluateDialog = false;
          } else {
            this.$message.error(res.msg);
          }
          this.handleClose(function () {
            console.log("关闭历程表");
          });
          this.evaluateDialog = false;
          done();
        })
        .catch((err) => {
          done();
        });
    },
    // 评价提交报错
    evaluateFormError(done) {
      done();
    },
    // 关闭评价弹窗
    closeEvaluateDialog(done) {
      this.evaluateForm = {};
      this.evaluateDialog = false;
      if (done) {
        done();
      }
      done();
    },
    // 延迟弹窗
    openDelayDialog(title) {
      this.$refs.Delay.openDialog({orderId:this.orderId,title:title,orderRow:this.orderRow});
    },
    // 延迟提交
    delayFormSubmit(form, done) {
      form.orderId = this.orderId;
      delay(form)
        .then((res) => {
          if (res.msg == "操作成功") {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.dialogVisible = false;
            this.delayDialog = false;
          } else {
            this.$message.error(res.msg);
          }
          this.handleClose(function () {
            console.log("关闭历程表");
          });
          this.delayDialog = false;
          done();
        })
        .catch((err) => {
          done();
        });
    },
    // 延迟提交报错
    delayFormError(done) {
      done();
    },
    // 关闭延迟弹窗
    closeDelayDialog(done) {
      this.delayForm = {
        attachList: [],
      };
      this.delayDialog = false;
      if (done) {
        done();
      }
    },
    // 恢复弹窗
    openRecoverDialog(title) {
        this.$refs.Recover.openDialog({orderId:this.orderId,title:title,orderRow:this.orderRow});

    },
    // 恢复提交
    recoverFormSubmit(form, done) {
      form.orderId = this.orderId;
      recover(form)
        .then((res) => {
          if (res.msg == "操作成功") {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.dialogVisible = false;
            this.recoverDialog = false;
          } else {
            this.$message.error(res.msg);
          }
          this.handleClose(function () {
            console.log("关闭历程表");
          });
          this.recoverDialog = false;
          done();
        })
        .catch((err) => {
          done();
        });
    },
    // 恢复提交报错
    recoverFormError(done) {
      done();
    },
    // 关闭恢复弹窗
    closeRecoverDialog(done) {
      this.recoverForm = {};
      this.recoverDialog = false;
      if (done) {
        done();
      }
      done();
    },
    // 完成弹窗
    openFinishDialog(index) {
        this.$refs.finish.openDialog({ orderId: this.orderId, actionType: index ,orderRow:this.orderRow});

      // getRemarkList({ orderId: this.orderId, actionType: index }).then((res) => {
      //   this.$refs.finishFormRemarkModel.setRemarkList(res.data);
      // });
      // this.finishDialog = true;
    },
    // wanc提交
    finishFormSubmit(form, done) {
      form.orderId = this.orderId;
      finish(form)
        .then((res) => {
          if (res.msg == "操作成功") {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.dialogVisible = false;
            this.finishDialog = false;
          } else {
            this.$message.error(res.msg);
          }
          this.handleClose(function () {
            console.log("关闭历程表");
          });
          this.finishDialog = false;
          done();
        })
        .catch((err) => {
          done();
        });
    },
    // wanc提交报错
    finishFormError(done) {
      done();
    },
    // 关闭完成弹窗
    closeFinishDialog(done) {
      this.finishForm = {
        attachList: [],
      };
      this.finishDialog = false;
      if (done) {
        done();
      }
      done();
    },
    // 外委弹窗
    openOutsourcingDialog(index) {
      this.$refs.Outsourcing.openDialog({
        orderId: this.orderId,
        actionType: index,
        projectId: this.projectId,
        orderRow:this.orderRow
      });
    },
    // 外委提交
    outsourcingFormSubmit(form, done) {
      form.orderId = this.orderId;
      outsourcing(form)
        .then((res) => {
          if (res.msg == "操作成功") {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.dialogVisible = false;
            this.outsourcingDialog = false;
          } else {
            this.$message.error(res.msg);
          }
          this.handleClose(function () {
            console.log("关闭历程表");
          });
          this.outsourcingDialog = false;
          done();
        })
        .catch((err) => {
          done();
        });
    },
    // 外委提交报错
    outsOurcingFormError(done) {
      done();
    },
    // 关闭外委弹窗
    closeoutsourcingDialog(done) {
      this.outsourcingForm = {};
      this.outsourcingDialog = false;
      if (done) {
        done();
      }
      done();
    },
    // 报废弹窗
    openScrapDialog(title) {
      this.$refs.Scrap.openDialog({orderId:this.orderId,title:title,orderRow:this.orderRow});
    
    },
    // 报废提交
    scrapFormSubmit(form, done) {
      form.orderId = this.orderId;
      scrap(form)
        .then((res) => {
          if (res.msg == "操作成功") {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.dialogVisible = false;
            this.scrapDialog = false;
          } else {
            this.$message.error(res.msg);
          }
          this.handleClose(function () {
            console.log("关闭历程表");
          });
          this.scrapDialog = false;
          done();
        })
        .catch((err) => {
          done();
        });
    },
    // 报废提交报错
    scrapFormError(done) {
      done();
    },
    // 关闭报废弹窗
    closeScrapDialog(done) {
      this.scrapForm = {
        attachList: [],
      };
      this.scrapDialog = false;
      if (done) {
        done();
      }
      done();
    },
    // 报修弹窗
    openRepairsDialog(index) {
      getRemarkList({ orderId: this.orderId, actionType: index }).then((res) => {
        this.$refs.repairsFormRemarkModel.setRemarkList(res.data);
      });
      // 报单人员
      getUserListByDepartmentId().then((res) => {
        this.requireUserList = res.data;
      });
      this.repairsDialog = true;
    },
    // 报修表单  -- 项目名称切换
    changeHandler_(value) {
      lazyAreaTree({ parentId: 0, projectId: value }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        this.treeFormAreaData = data;
      });
    },
    // 报修表单  --需求区域数据
    editAreaLazyLoadTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      lazyAreaTree({ parentId: id, projectId: this.projectId }).then(
        ({ data }) => {
          if (data instanceof Array) {
            data.forEach((item) => {
              item.hasChildren = !item.hasChildren;
            });
          }
          resolve(data);
        }
      );
    },
    editAreaNodeTreeClick_(node) {
      setTimeout(() => {
        let nodeId = node.id;
        let nodeTitle = node.name;
        // this.form.areaName = nodeTitle;
        // this.form.areaId = nodeId;

        this.repairsForm = Object.assign({}, this.repairsForm, {
          areaName: nodeTitle,
          areaId: nodeId,
        });
        this.$refs.addConnectSelect.blur();
        this.areaNameFlag = true;
        this.areaIdFlag = false;
      }, 0);
    },

    _editAreaNodeTreeClick(node) {
      if(parseInt(node.nodeType)==1){
            // this.$message.error();
                return;
            }
      setTimeout(() => {
        let nodeId = node.id;
        let nodeTitle = node.name;
        // this.form.areaName = nodeTitle;
        // this.form.areaId = nodeId;

        this.startOrderForm = Object.assign({}, this.repairsForm, {
          areaName: nodeTitle,
          areaId: nodeId,
        });
        this.$refs.addConnectSelect.blur();
        this.areaNameFlag = true;
        this.areaIdFlag = false;
      }, 0);
    },
    changeRequireUserHandler_(val) {
      let tempRequiredUserName = "";
      this.requireUserList.forEach((ele, index) => {
        if (val === ele.id) {
          tempRequiredUserName = ele.realName;
        }
      });
      this.repairsForm.requireManName = tempRequiredUserName;
    },
    // 报修提交
    repairsFormSubmit(form, done) {
      form.projectId = this.projectId;
      form.moduleType = this.moduleType;
      form.oldOrderId = this.orderId;
      form.moduleJson = "{}";
      form.areaId = this.orderDetailForm.areaId;
      form.source = "4";
      form.requireMainId = this.userInfo.user_id;
      form.requireManName = this.userInfo.user_name;
      form.deptId = this.orderDetailForm.deptId;
      repairs(form)
        .then((res) => {
          if (res.msg == "操作成功") {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.dialogVisible = false;
            this.repairsDialog = false;
          } else {
            this.$message.error(res.msg);
          }
          this.handleClose(function () {
            console.log("关闭历程表");
          });
          this.repairsDialog = false;
          done();
        })
        .catch((err) => {
          done();
        });
    },
    // 报修提交报错
    repairsFormError(done) {
      done();
    },
    // 关闭报修弹窗
    closeRepairsDialog(done) {
      this.repairsForm = {
        attachList: [],
      };
      this.repairsDialog = false;
      if (done) {
        done();
      }
      done();
    },
    // 取消弹窗
    openCancelDialog(index) {
      this.$refs.cencel.openDialog({orderId:this.orderId,orderRow:this.orderRow});
    },
    // 取消提交
    cancelFormSubmit(form, done) {
      form.orderId = this.orderId;
      cancel(form)
        .then((res) => {
          if (res.msg == "操作成功") {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.cancelDialog = false;
            this.dialogVisible = false;
          } else {
            this.$message.error(res.msg);
          }
          this.handleClose(function () {
            console.log("关闭历程表");
          });
          this.cancelDialog = false;
          done();
        })
        .catch((err) => {
          done();
        });
    },
    // 取消提交报错
    cancelFormError(done) {
      done();
    },
    // 关闭取消弹窗
    closeCancelDialog(done) {
      this.cancelForm = {
        attachList: [],
      };
      this.cancelDialog = false;
      if (done) {
        done();
      }
      done();
    },

    // 开始弹窗
    openStartOrderDialog(index) {
      this.$refs.start.openDialog({
        orderId: this.orderId,
        actionType: index,
        projectId: this.projectId,
        orderRow:this.orderRow
      })
      // getRemarkList({ orderId: this.orderId, actionType: index }).then((res) => {
      //   this.$refs.startOrderFormRemarkModel.setRemarkList(res.data);
      // });
      // this.startOrderDialog = true;
    },
    // 开始提交
    startOrderFormSubmit(form, done) {
      form.orderId = this.orderId;
      start(form)
        .then((res) => {
          if (res.msg == "操作成功") {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.robOrderDialog = false;
            this.dialogVisible = false;
          } else {
            this.$message.error(res.msg);
          }
          this.handleClose(function () {
            console.log("关闭历程表");
          });
          this.robOrderDialog = false;
          done();
        })
        .catch((err) => {
          done();
        });
    },
    // 开始提交报错
    startOrderFormError(done) {
      done();
    },
    // 关闭开始弹窗
    closeStartOrderDialog(done) {
      this.startOrderForm = {
        attachList: [],
      };
      this.startOrderDialog = false;
      if (done) {
        done();
      }
      done();
    },
    // 打开抢单/接受弹窗
    openRobOrderDialog(title) {
      this.$refs.Receive.openDialog({orderId:this.orderId,title:title,orderRow:this.orderRow});
    },
    // 抢单/接受提交
    robOrderFormSubmit(form, done) {
      form.orderId = this.orderId;
      accept(form)
        .then((res) => {
          if (res.msg == "操作成功") {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.robOrderDialog = false;
            this.dialogVisible = false;
          } else {
            this.$message.error(res.msg);
          }
          this.handleClose(function () {
            console.log("关闭历程表");
          });
          done();
        })
        .catch((err) => {
          done();
        });
    },
    // 抢单/接受提交报错
    robOrderFormError(done) {
      done();
    },
    // 关闭抢单/接受弹窗
    closeRobOrderDialog(done) {
      this.robOrderForm = {};
      this.robOrderDialog = false;
      if (done) {
        done();
      }
      done();
    },

     // 打开派单弹窗
    openAssignDialog(index) {
      this.$refs.Appoint.openDialog({orderId:this.orderId,subModuleId:this.orderDetailForm.subModuleId,orderRow:this.orderRow});

    },
    // 抢单弹窗
    openGrabSingleDialog(index){
       this.$refs.GrabSingle.openDialog({orderId:this.orderId,orderRow:this.orderRow});
    },


    // 打开转办弹窗
    openComplaintDialog(index) {
      this.$refs.complaint.openDialog(this.orderId,this.orderDetailForm.subModuleId,this.orderRow);
      return;
      // getRemarkList({ orderId: this.orderId, actionType: index }).then((res) => {
      //   this.$refs.complaintFormRemarkModel.setRemarkList(res.data);
      // });

      // this.complaintDialog = true;
      // getGroupDetails({ orderId: this.orderId }).then((res) => {
      //   this.complaintForm.group = res.data.name;
      //   this.$refs.complaintForm.updateDic("handerId", res.data.userList);
      // });
    },
    // 转办提交
    complaintFormSubmit(form, done) {
      form.orderId = this.orderId;

      complaint(form)
        .then((res) => {
          if (res.msg == "操作成功") {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.complaintDialog = false;
            this.dialogVisible = false;
          } else {
            this.$message.error(res.msg);
          }
          this.handleClose(function () {
            console.log("关闭历程表");
          });
          this.complaintDialog = false;
          done();
        })
        .catch((err) => {
          done();
        });
    },
    // 转办提交报错
    complaintFormError(done) {
    },
    // 关闭转办弹窗
    closeComplaintDialog(done) {
      this.complaintForm = {};
      this.complaintDialog = false;
      if (done) {
        done();
      }
      done();
    },
  },
};
</script>
<style lang="scss" scoped>
.test {
  justify-content: space-between;
  justify-content: flex-end;
  flex-shrink: 1;
  flex-grow: 1;
}
.order-detail {
  flex-shrink: 1;
  flex-grow: 1;
}
.course {
  flex-shrink: 0;
  flex-grow: 0;
  width: 260px;
  padding: 20px;
  padding-right: 10px;
  border-left: 2px solid #eee;
  height: 600px;
  overflow: hidden;
  overflow-y: auto;
}
td {
  // border: 1px solid #999;
  height: 40px;
  line-height: 40px;
  min-width: 80px;
  text-align: center;
}
.add-height {
  height: 120px;
  text-align: left;
  padding: 10px;
  text-indent: 2rem;
}
.title-name {
  font-weight: bold;
}
.add-width {
  width: 100px;
}
.step-icon {
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  // background-color: #eee;
  border-radius: 50%;
}
.fileStyle {
  padding: 5px 5px;
  background-color: #eee;
  margin: 5px 0px;
}
.fileStyle:hover {
  // background-color:#333;
  position: relative;
  top: -1px;
  left: -1px;
}
</style>
>
